import React from 'react';

const Success = () => {
  return (
    <div className='flex flex-col justify-center items-center py-5 gap-5'>
      <h2 className='font-bold text-3xl bg-green-700 text-white p-3 px-10 rounded-lg'>عملیات با موفقیت انجام شد</h2>

      <div className='flex flex-col justify-center items-center gap-1'>
        <span className='font-bold text-2xl'>:شماره پیگیری</span>
        <span>l;sfkdaj;lkdfsa</span>
      </div>

      <p>جهت پیگیری سفارش با شماره 07142217055</p>
    </div>
  )
}

export default Success